import { render, staticRenderFns } from "./AlCard.vue?vue&type=template&id=62b61c66&"
import script from "./AlCard.vue?vue&type=script&lang=js&"
export * from "./AlCard.vue?vue&type=script&lang=js&"
import style0 from "./AlCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports